import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import { ProductPageContext } from './Calendar';

import { useTranslation } from 'react-i18next';
// import useElDimensions from '../hooks/useElDimensions';
import usePropsBeforeContext from '../hooks/usePropsBeforeContext';

import ChooseProductMasonry from './base/ChooseProductMasonry';
import ChooseProductCard from './base/ChooseProductCard';
export default function ProductSelector(props) {
  // const [headlineRef, headlineDimensions] = useElDimensions();
  const { t } = useTranslation();

  const {
    onProductSelected,
    products = [],
    selectProduct,
  } = usePropsBeforeContext(props, ProductPageContext);

  if (products?.length === 1) {
    selectProduct(products[0]);
    if (onProductSelected) {
      onProductSelected(products[0]);
    }
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h4" component={'h2'}>
          {t('product_selection_headline')}
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ maxHeight: '100%', overflow: 'auto' }}>
        <ChooseProductMasonry products={products} isLoading={false}>
          {products.map((product, index) => (
            <ChooseProductCard
              index={index}
              key={product.uuid}
              title={product.name}
              description={product.detailsPre}
              minDuration={product.minDuration}
              titleTypographyProps={{
                variant: 'body1',
              }}
              onSelectProduct={() => {
                selectProduct(product);
                if (onProductSelected) {
                  onProductSelected();
                }
              }}
            />
          ))}
        </ChooseProductMasonry>
      </Grid>
    </Grid>
  );
}

ProductSelector.propTypes = {
  /** callback for parent to trigger action on produc selection */
  onProductSelected: PropTypes.func,
};
